import Vue from 'vue'
import 'default-passive-events'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import './css/Common/_common.scss'
import './css/Common/reset.css'
import './css/Common/base.scss'

import './plugins/elementui'
import './plugins/components' // 全局组件
import './configs/Filters' // 全局过滤器

// import 'default-passive-events'

// import 'babel-polyfill'//兼容IE11

Vue.use(ElementUI);

require('promise.prototype.finally').shim()
Vue.config.productionTip = false

export default new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
